var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',[_c('v-card',{staticClass:"ma-3"},[_c('v-card-title',[_c('h2',[_vm._v("Solicitudes")])]),_c('v-card-text',[_c('laboral-requests',{attrs:{"admin-view":true}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }